import React from 'react'

import useBreakpoints from '../hooks/use-breakpoints'

import Button from '../../../commons/src/components/button'
import Grid from '../../../commons/src/components/grid'
import GridCell from '../../../commons/src/components/grid/GridCell'

interface Props {
  title: React.ReactNode
  image: React.ReactNode
  headerContent?: React.ReactNode
  content: React.ReactNode
  sidebar: React.ReactNode
}

const DetailViewPartial = ({title, image, headerContent, content, sidebar}: Props) => {
  const breakpoints = useBreakpoints()

  const button = (
    <Button
      className="u-margin-bottom-l"
      as="a"
      href="https://support.craftcloud3d.com/en/articles/32-design-guide"
      target="_blank"
      hierarchy="secondary"
      block
    >
      3D Design Guide
    </Button>
  )

  return (
    <Grid space="400">
      <GridCell m={6} l={5}>
        {title}
        {!breakpoints.tablet && image}
        {breakpoints.tablet && headerContent}
        {breakpoints.tablet && button}
      </GridCell>
      <GridCell m={6} l={7}>
        {!breakpoints.tablet && headerContent}
        {!breakpoints.tablet && button}
        {breakpoints.tablet && image}
      </GridCell>
      <GridCell m={7} l={8}>
        {content}
      </GridCell>
      <GridCell m={5} l={4}>
        {sidebar}
      </GridCell>
    </Grid>
  )
}

export default DetailViewPartial
